module.exports = __webpack_public_path__ + "static/media/sv1.2d33e19f.jpg";